import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function showError(_x, _x2) {
  return _showError.apply(this, arguments);
}

function _showError() {
  _showError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(evt, _this) {
    var error, errorValue;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            error = _this.props.error;

            if (!(error == null)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            if (!(typeof error === 'function')) {
              _context.next = 9;
              break;
            }

            _context.next = 6;
            return error(evt);

          case 6:
            errorValue = _context.sent;
            _context.next = 10;
            break;

          case 9:
            errorValue = error;

          case 10:
            // set error state based on error value
            if (typeof errorValue === 'boolean') _this.setState({
              error: errorValue
            });else console.error('"Error" prop should be a boolean or a function that returns a boolean value.');

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _showError.apply(this, arguments);
}

export default showError;